function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classNames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getPlanColor } from "services/pricing/plans-service";
import { getPricingDimensions } from "/services/pricing/pricing-page/pricing-page-display-service";
import PricingActionButton from "segments/desktop/core-components/pricing-action-button/pricing-action-button";
import { isDesktopMinisiteSecondaryMenuActive } from "segments/desktop/header/layouts/base-header/base-header-service";
import { StyledStickyTableHeaderComponent } from "./sticky-table-header-component.scss";
class StickyTableHeaderComponent extends PureComponent {
    componentDidMount() {
        const { isClusterMiniSitePage } = this.props;
        if (isClusterMiniSitePage) {
            window.addEventListener("scroll", this.stickyScrollingHandler, {
                passive: true
            });
        }
    }
    componentWillUnmount() {
        const { isClusterMiniSitePage } = this.props;
        if (isClusterMiniSitePage) {
            window.removeEventListener("scroll", this.stickyScrollingHandler);
        }
    }
    render() {
        const { plans, translateOrTranslateWithParam, hasBorder } = this.props;
        const { shouldIncreaseStickyTopPosition } = this.state;
        const pricingDimensions = getPricingDimensions(plans);
        const { featuresSection: featuresSectionDimensions } = pricingDimensions;
        const { featureWidth, planWidth } = featuresSectionDimensions;
        const sectionNameStyle = {
            width: `${featureWidth}%`
        };
        const planNameStyle = {
            width: `${planWidth}%`
        };
        return /*#__PURE__*/ _jsxs(StyledStickyTableHeaderComponent, {
            className: classNames("sticky-table-header-container", {
                "with-border": hasBorder,
                "scrolling-upwards-minisite": shouldIncreaseStickyTopPosition
            }),
            role: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "pick-your-plan-text",
                    role: "columnheader",
                    style: sectionNameStyle
                }),
                plans.map((plan)=>/*#__PURE__*/ _jsxs("div", {
                        className: "tier-section",
                        style: planNameStyle,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "tier-name",
                                style: {
                                    color: getPlanColor(plan, true)
                                },
                                role: "columnheader",
                                children: translateOrTranslateWithParam(plan.displayName)
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tier-button",
                                children: /*#__PURE__*/ _jsx(PricingActionButton, {
                                    plan: plan,
                                    placement: "features-table-sticky-header",
                                    signupButtonText: translateOrTranslateWithParam("signup.tryForFree"),
                                    contactUsButtonText: translateOrTranslateWithParam("footer.contactUs")
                                })
                            })
                        ]
                    }, plan.tier))
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "stickyScrollingHandler", ()=>{
            const { isClusterMiniSitePage } = this.props;
            if (!isClusterMiniSitePage) return; // no need to modify the top position if we're not scrolling.
            setTimeout(()=>{
                this.setState({
                    shouldIncreaseStickyTopPosition: isDesktopMinisiteSecondaryMenuActive()
                });
            }, 0); // we want this to happen after any other setState-s.
        });
        this.state = {
            shouldIncreaseStickyTopPosition: false
        };
    }
}
export default withGenericConfig(StickyTableHeaderComponent);
